import { Button } from "reactstrap";

const ViewRecordButton = ({ onClick }) => {
  return (
    <Button
      className={"btn-icon-only mr-0"}
      size="sm"
      color="secondary"
      outline
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
    >
      <i className="mdi mdi-eye-outline"></i>
    </Button>
  );
};

export default ViewRecordButton;
